module.exports = __webpack_public_path__ + "static/043.thumb-3c98e0bd2d5e4d19b7d1e9954862bdac.jpg";